import { IDynamicConfig, IDynamicFormConfig, DynamicConfig } from '@mt-ng2/dynamic-form';
import { CustomerNonTwicTimingDynamicControlsPartial } from '../model/partials/customer-non-twic-timing-partial.form-controls';
import { ICustomerNonTwicTiming } from '../model/interfaces/customer-non-twic-timing';
import { ICustomerNonTwicTimingDynamicControlsParameters } from '../model/form-controls/customer-non-twic-timing.form-controls';

export class CustomerNonTwicTimingDynamicConfig<T extends ICustomerNonTwicTiming> extends DynamicConfig<T> implements IDynamicConfig<T> {
    constructor(private customerpickupoverride: T, private configControls?: string[]) {
        super();
        const additionalParams: ICustomerNonTwicTimingDynamicControlsParameters = {};
        const dynamicControls = new CustomerNonTwicTimingDynamicControlsPartial(this.customerpickupoverride, additionalParams);
        // default form implementation can be overridden at the component level
        if (!configControls) {
            this.configControls = ['StartTime', 'EndTime', 'FromDate', 'ToDate'];
        }
        this.setControls(this.configControls, dynamicControls);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getForUpdate(additionalConfigs?: any[]): IDynamicFormConfig {
        return {
            formObject: this.getFormObject(additionalConfigs),
            viewOnly: this.DynamicLabels,
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getForCreate(additionalConfigs?: any[]): IDynamicFormConfig {
        return {
            formObject: this.getFormObject(additionalConfigs),
        };
    }
}
